import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';

const PHONE_DISPLAY = '(505) 589-3461';
const PHONE_HREF = 'tel:+15055893461';

/**
 * Floating click-to-call button, fixed bottom-left so it never overlaps the
 * bottom-right chat widget. Visible on every page as users scroll.
 */
export const FloatingCallButton = () => {
    return (
        <motion.a
            href={PHONE_HREF}
            data-testid="floating-call-button"
            aria-label={`Call MSD Painting Services at ${PHONE_DISPLAY}`}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1, ease: [0.7, 0, 0.2, 1] }}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
            className="fixed bottom-5 left-5 z-[60] group flex items-center gap-3 rounded-full py-3.5 pl-3.5 pr-5 shadow-[0_14px_40px_rgba(0,0,0,0.45)] ring-1 ring-white/10 backdrop-blur-sm transition-colors"
            style={{ backgroundColor: 'rgba(23,27,33,0.92)' }}
        >
            <span
                className="flex items-center justify-center w-9 h-9 rounded-full shrink-0 transition-transform group-hover:rotate-6"
                style={{ backgroundColor: '#B9AFA1' }}
            >
                <Phone size={16} strokeWidth={2} style={{ color: '#0B0D10' }} />
            </span>
            <span className="flex flex-col leading-none">
                <span
                    className="font-mono text-[9px] tracking-[0.28em] uppercase mb-1"
                    style={{ color: '#707A70' }}
                >
                    Call Us
                </span>
                <span
                    className="font-semibold text-[14px] tracking-tight"
                    style={{ color: '#F2EFE8' }}
                >
                    {PHONE_DISPLAY}
                </span>
            </span>
        </motion.a>
    );
};
